// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__23f-x","tab":"ProcedureTabs_tab__29I7V"};